import { Star } from "lucide-react";
import { GoogleIcon, StarRating } from "@/components/ui/Icons";
import { memo } from "react";

export const AvaliacoesSection = memo(({ sectionRef, isVisible, testimonials }) => {
  return (
    <section 
      ref={sectionRef}
      className={`py-12 md:py-16 bg-gradient-to-b from-[#f8fafc] to-white transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      data-testid="avaliacoes-section"
    >
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-2 mb-4">
            <GoogleIcon />
            <span className="font-bold text-[#002776] text-lg">4.7</span>
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={`star-rating-${i}`} className={`w-5 h-5 ${i < 5 ? 'fill-[#FFDF00] text-[#FFDF00]' : 'text-gray-300'}`} />
              ))}
            </div>
            <span className="text-gray-500 text-sm">(550+ avaliações)</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl text-[#002776]">
            O QUE DIZEM NOSSOS CLIENTES
          </h2>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.slice(0, 6).map((t) => (
            <div key={t.id || `testimonial-${t.name}`} className="bg-white rounded-2xl p-6 shadow-md border border-gray-100">
              <div className="flex items-center gap-4 mb-4">
                <img src={t.photo} alt={t.name} loading="lazy" className="w-12 h-12 rounded-full object-cover border-2 border-[#009C3B]"/>
                <div>
                  <h4 className="font-bold text-[#002776]">{t.name}</h4>
                  <p className="text-sm text-gray-500">{t.location}</p>
                </div>
              </div>
              <StarRating rating={t.rating} />
              <p className="text-gray-600 mt-3 text-sm leading-relaxed">"{t.text}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

export default AvaliacoesSection;
